import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomItemsMutationVariables = Types.Exact<{
  input: Types.CreateCustomItemsInput;
}>;


export type CreateCustomItemsMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly createCustomItems: { readonly __typename?: 'CreateCustomItemsResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'PriceableItem', readonly id: string, readonly name: string }> } } };


export const CreateCustomItemsDocument = gql`
    mutation createCustomItems($input: CreateCustomItemsInput!) {
  priceListV2 {
    createCustomItems(input: $input) {
      items {
        id
        name
      }
    }
  }
}
    `;
export type CreateCustomItemsMutationFn = Apollo.MutationFunction<CreateCustomItemsMutation, CreateCustomItemsMutationVariables>;

/**
 * __useCreateCustomItemsMutation__
 *
 * To run a mutation, you first call `useCreateCustomItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomItemsMutation, { data, loading, error }] = useCreateCustomItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomItemsMutation, CreateCustomItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomItemsMutation, CreateCustomItemsMutationVariables>(CreateCustomItemsDocument, options);
      }
export type CreateCustomItemsMutationHookResult = ReturnType<typeof useCreateCustomItemsMutation>;
export type CreateCustomItemsMutationResult = Apollo.MutationResult<CreateCustomItemsMutation>;
export type CreateCustomItemsMutationOptions = Apollo.BaseMutationOptions<CreateCustomItemsMutation, CreateCustomItemsMutationVariables>;